import React, {Component} from 'react';
import {connect} from 'react-redux';

import 'ol/ol.css';
import Map from 'ol/Map';
import View from 'ol/View';
import {transformExtent} from 'ol/proj.js';
import ScaleLine from 'ol/control/ScaleLine';
import Tile from 'ol/layer/Tile';
import Image from 'ol/layer/Image';
import Vector from 'ol/layer/Vector';
import TileWMS from 'ol/source/TileWMS';
import ImageWMS from 'ol/source/ImageWMS';
import TileArcGISRest from 'ol/source/TileArcGISRest';
import Draw from 'ol/interaction/Draw';
import moment from 'moment';

import {
    activateLayer,
    activateSubLayer,
    displayDetailPanel,
    displayGeoserverAlertPopup,
    displayMapTooltip,
    displayMultistack,
    displayOpacitySlider,
    drawModeAnalyze,
    drawModePolygonRegister,
    updateBaseLayer,
    updateMapProperties,
    zoomMapToExtent
} from '../../actions';

import {clickableLayers} from '../../config';
import VectorSource from 'ol/source/Vector';
import GeoJSON from 'ol/format/GeoJSON';
import Style from 'ol/style/Style';
import CircleStyle from 'ol/style/Circle';
import Icon from 'ol/style/Icon';
import Fill from 'ol/style/Fill';
import Stroke from 'ol/style/Stroke';
import hexToRgba from 'hex-to-rgba';
import MultiPoint from 'ol/geom/MultiPoint';
import Point from 'ol/geom/Point';
import {getArea, getLength} from 'ol/sphere';
import Polygon, {circular as circularPolygon} from 'ol/geom/Polygon';
import LineString from 'ol/geom/LineString';
import self from '../../apis/self';
import {Feature} from 'ol';

/**
 * React Component that handles Map operation
 */
let map = '';
let layerList = [];
let layers = [];
let baseLayers = [];
let clickedLayer = '';
let clickedLayerInner = '';
let radiusLayer;
let draw;
let prevDrawType;
let drawSource;
let drawVector;
let adhocLayers = [];
let adhocLayersObject = [];
let adhocLayersIndex = [];
let coordinateSearchLayer;
let coordinateSearchLayerSource;

class MapComponent extends Component {
    constructor(props) {
        super(props);
        // const projection = new Projection({
        //     code: 'EPSG:4326',
        // });
        this.layersloaded = 0;

        /* init base layer variable*/
        baseLayers['grey_basemap'] = new Tile({
            visible: false,
            source: new TileArcGISRest({
                // url: 'https://services.arcgisonline.com/arcgis/rest/services/Canvas/World_Light_Gray_Base/MapServer',
                url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Shaded_Relief/MapServer/',
                crossOrigin: 'anonymous',
                params: {
                    FORMAT: 'JPG',
                }
            }),
            opacity: 0.5
        });

        baseLayers['grey_basemap'].on('postcompose', (event) => {
            this.greyscale(event.context);
            // baseLayers['grey_basemap'].setOpacity(0.1);
        });

        baseLayers['grey_basemap'].set('name', 'grey_basemap');


        baseLayers['sat_basemap'] = new Tile({
            visible: false,
            source: new TileArcGISRest({
                url: 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer',
                crossOrigin: 'anonymous',
                params: {
                    FORMAT: 'JPG',
                }
            })
        });

        baseLayers['sat_basemap'].set('name', 'sat_basemap');

        baseLayers['rbi_basemap'] = new Tile({
            visible: false,
            source : new TileArcGISRest({
                url        : 'https://portal.ina-sdi.or.id/arcgis/rest/services/RBI/INDONESIA/MapServer',
                crossOrigin: 'anonymous',
                params: {
                    FORMAT: 'JPG',
                }
            })
        });

        baseLayers['rbi_basemap'].set('name', 'rbi_basemap');

        layerList = [
            baseLayers['grey_basemap'],
            baseLayers['sat_basemap'],
            baseLayers['rbi_basemap'],
        ];

        /* set base layer*/
        this.props.updateBaseLayer("grey_basemap");

        const scaleLine = new ScaleLine({
            units: 'metric',
        });

        /* init maps variable */
        map = new Map({
            layers    : layerList,
            projection: 'EPSG:4326',
            controls  : [scaleLine],
            view      : new View({
                projection: 'EPSG:4326',
                // center: this.props.mapProperties.center,
                // zoom: this.props.mapProperties.zoom,
                // extent: [88.359375, -16.2158203125, 151.640625, 16.2158203125],
                // extent: [64.06639363327358, -30.59395522264306, 190.62889363327358, 28.60038071485694],
                center    : [120, 0],
                zoom      : 5,
                minZoom   : 5,
                maxZoom   : 20
            }),
            events: {
                map: ['pointermove', 'mousemove'],
            }
        });

        /* draw mode initialization */
        drawSource = new VectorSource({wrapX: false});
        drawVector = new Vector({
            source: drawSource,
        });
        map.addLayer(drawVector);
        drawVector.setZIndex(1000000);
        draw = new Draw({
            source: drawSource,
            type  : 'None'
        })
        map.removeInteraction(draw);

        /* coordinate search layer initialization */
        coordinateSearchLayerSource = new VectorSource({
            wrapX: false,
        });
        coordinateSearchLayer = new Vector({
            source: coordinateSearchLayerSource
        });
        map.addLayer(coordinateSearchLayer);
        coordinateSearchLayer.setZIndex(1000000);
    }

    /**
     * function applies greyscale to every pixel in canvas
     */
    greyscale(context) {
        const canvas = context.canvas;
        const width = canvas.width;
        const height = canvas.height;
        let imageData = context.getImageData(0, 0, width, height);
        imageData.crossOrigin = 'anonymous';
        const data = imageData.data;
        for(let i=0; i<data.length; i += 4){
            const r = data[i];
            const g = data[i + 1];
            const b = data[i + 2];
            // CIE luminance for the RGB
            let v = 0.2126 * r + 0.7152 * g + 0.0722 * b;
            // Show white color instead of black color while loading new tiles:
            if(v === 0.0) {
                v = 255.0;
            }
            // console.log(v);
            data[i+0] = v+30; // Red
            data[i+1] = v+30; // Green
            data[i+2] = v+30; // Blue
            data[i+3] = 255; // Alpha
        }
        context.putImageData(imageData,0,0);
    }

    componentDidMount(){
        /* set target element */
        map.setTarget('map');

        /* drag and zoom event listener*/
        map.on('moveend', () => {
            const center = map.getView().getCenter();
            const zoom = map.getView().getZoom();
            this.props.updateMapProperties({
                center: center,
                zoom  : zoom,
            });
            this.props.zoomMapToExtent([]);
        });

        map.on('movestart', () => {
            this.props.displayMapTooltip({
                status: false,
            });
            this.props.displayMultistack({
                status: false,
            });
        });

        this.mapHoverEventHandler();
        this.mapClickEventHandler();

    }

    getSnapshotBeforeUpdate(prevProps) {
        return {
            changeBaseLayer: prevProps.baseLayers !== this.props.baseLayer,
            zoomToExtent: prevProps.mapExtent !== this.props.mapExtent,
            updateMapProperties: prevProps.mapProperties !== this.props.mapProperties,
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        /* update base map */
        if (snapshot.changeBaseLayer) {
            Object.keys(baseLayers).forEach(layerName => {
                baseLayers[layerName].setVisible(false);
            });
            baseLayers[this.props.baseLayer].setVisible(true);
        }

        /* create layer */
        if (Object.keys(layers).length == 0) {
            this.props.layers.map((parentLayer) => {
                parentLayer.layers.map((layer) => {
                    if (layer.layer_active && layer.layer_active.layer_lists) {
                        if (layer.layer_active.mode === "checkbox") {
                            // TODO: checkbox sub layer handler
                        }
                        layer.layer_active.layer_lists.map((layer_item, index) => {
                            /* process tileWMS od imageWMS layer*/
                            if ((layer_item.layer_type === 'tilewms' || layer_item.layer_type === 'imagewms') && layer_item.layer_name != null) {
                                let layerWorkspaceArr = [];
                                let layerNameArr = [];
                                let layersParamString = '';

                                if(layer_item.layer_workspace){
                                    layerWorkspaceArr = layer_item.layer_workspace.split(';');
                                }
                                layerNameArr = layer_item.layer_name.split(';');

                                layerNameArr.map((layerName, i) =>{
                                    if(i > 0){
                                        layersParamString += ',';
                                    }
                                    if(layerWorkspaceArr[i]) {
                                        layersParamString += `${layerWorkspaceArr[i]}:`;
                                    }
                                    layersParamString += `${layerNameArr[i]}`;
                                });

                                if (layer_item.layer_type === 'tilewms') {
                                    layers[layer_item.id] = new Tile({
                                        visible: false,
                                        source : new TileWMS({
                                            url        : process.env.MIX_PRIMS_GEOSERVER_WMS_URL,
                                            params     : {
                                                // 'LAYERS'    : (layer_item.layer_workspace ? layer_item.layer_workspace + ':' : '') + layer_item.layer_name,
                                                'LAYERS'    : layersParamString,
                                                'TILED'     : true,
                                                'FORMAT'    : 'image/png',
                                                'VERSION'   : '1.1.0',
                                                'CQL_FILTER': layer_item.layer_filter,
                                            },
                                            serverType : 'geoserver',
                                            crossOrigin: 'anonymous',
                                        })
                                    });
                                } else if (layer_item.layer_type === 'imagewms') {
                                    layers[layer_item.id] = new Image({
                                        visible: false,
                                        source : new ImageWMS({
                                            url        : process.env.MIX_PRIMS_GEOSERVER_WMS_URL,
                                            params     : {
                                                // 'LAYERS'    : (layer_item.layer_workspace ? layer_item.layer_workspace + ':' : '') + layer_item.layer_name,
                                                'LAYERS'    : layersParamString,
                                                'TILED'     : true,
                                                'FORMAT'    : 'image/png',
                                                'VERSION'   : '1.1.0',
                                                'CQL_FILTER': layer_item.layer_filter,
                                            },
                                            serverType : 'geoserver',
                                            crossOrigin: 'anonymous',
                                        })
                                    });
                                }
                                layers[layer_item.id].set('name', layer_item.label);
                                layers[layer_item.id].set('clickable_name', layer_item.layer_workspace + ':' + layer_item.layer_name + (layer_item.layer_filter ? ':' + layer_item.layer_filter : ''));

                                layers[layer_item.id].set('layerId', layer_item.id);
                                layers[layer_item.id].set('parentId', layer.id);
                                layers[layer_item.id].set('parentName', layer.title);

                                map.addLayer(layers[layer_item.id]);

                                /* set layer error handler */
                                const source = layers[layer_item.id].getSource();

                                source.on('tileloaderror', (evt) => {
                                    if (source === evt.target) {
                                        if (this.props.geoserverAlertPopupData.status === false && this.props.geoserverAlertPopupData.layerName != layers[layer_item.id].get('name')) {
                                            console.log(`tileloaderror: ${layer_item.layer_workspace}:${layer_item.layer_name}`);
                                            /* check if layer active */
                                            const isActiveLayer = this.props.activeLayers.find(obj => {
                                                return obj.id === layer.id;
                                            });
                                            if (isActiveLayer) {
                                                if(isActiveLayer.layer_active.mode === 'radio' || isActiveLayer.layer_active.mode === 'checkbox'){
                                                    isActiveLayer.layer_active.layer_lists.forEach(function(subLayer, index){
                                                        if (subLayer.id === layer_item.id){
                                                            subLayer.is_active = false;
                                                        }
                                                    });
                                                    this.props.activateSubLayer(isActiveLayer);
                                                    /* display error popup */
                                                    this.props.displayGeoserverAlertPopup({
                                                        status   : true,
                                                        layerName: layers[layer_item.id].get('name'),
                                                    });
                                                }
                                                else {
                                                    this.props.activateLayer(layer);
                                                    /* display error popup */
                                                    this.props.displayGeoserverAlertPopup({
                                                        status   : true,
                                                        layerName: layer.title,
                                                    });
                                                }
                                            }
                                        }
                                    }
                                });

                                source.on('imageloaderror', (evt) => {
                                    if (source === evt.target) {
                                        if (this.props.geoserverAlertPopupData.status === false && this.props.geoserverAlertPopupData.layerName != layers[layer_item.id].get('name')) {
                                            console.log(`imageloaderror: ${layer_item.layer_workspace}:${layer_item.layer_name}`);
                                            /* check if layer active */
                                            const isActiveLayer = this.props.activeLayers.find(obj => {
                                                return obj.id === layer.id;
                                            });
                                            if (isActiveLayer) {
                                                if(isActiveLayer.layer_active.mode === 'radio' || isActiveLayer.layer_active.mode === 'checkbox'){
                                                    isActiveLayer.layer_active.layer_lists.forEach(function(subLayer, index){
                                                        if (subLayer.id === layer_item.id){
                                                            subLayer.is_active = false;
                                                        }
                                                    });
                                                    this.props.activateSubLayer(isActiveLayer);
                                                    /* display error popup */
                                                    this.props.displayGeoserverAlertPopup({
                                                        status   : true,
                                                        layerName: layers[layer_item.id].get('name'),
                                                    });
                                                }
                                                else {
                                                    this.props.activateLayer(layer);
                                                    /* display error popup */
                                                    this.props.displayGeoserverAlertPopup({
                                                        status   : true,
                                                        layerName: layer.title,
                                                    });
                                                }
                                            }
                                        }
                                    }
                                });

                                /* set detail panel */
                                if (layer_item.layer_detail) {
                                    let newClickableLayer = layer_item.layer_detail;
                                    // newClickableLayer.name = layer_item.layer_workspace + ':' + layer_item.layer_name + ( layer_item.layer_filter ? ':' + layer_item.layer_filter : '');
                                    newClickableLayer.name = layer_item.id;
                                    newClickableLayer.mode = newClickableLayer.type;
                                    newClickableLayer.type = 'modular';
                                    newClickableLayer.layerSource = layer_item.layer_type;
                                    clickableLayers.push(newClickableLayer);
                                }
                            }
                            /* process JSON layer */
                            else if (layer_item.layer_type === 'json' && layer_item.layer_url != null) {
                                layers[layer_item.id] = new Vector({
                                    visible: false,
                                    source : new VectorSource({
                                        url        : layer_item.layer_url,
                                        format     : new GeoJSON(),
                                        crossOrigin: 'anonymous',
                                    }),
                                    style  : new Style({
                                        image: new CircleStyle({
                                            radius: 5,
                                            fill  : new Fill({
                                                color: layer_item.hex
                                            }),
                                            stroke: new Stroke({
                                                color: '#ffffff',
                                                width: 1
                                            })
                                        })
                                    })
                                });
                                layers[layer_item.id].set('name', layer_item.label);
                                layers[layer_item.id].set('clickable_name', 'geojson:' + layer_item.layer_url);

                                layers[layer_item.id].set('layerId', layer_item.id);
                                layers[layer_item.id].set('parentId', layer.id);
                                layers[layer_item.id].set('parentName', layer.title);

                                map.addLayer(layers[layer_item.id]);

                                /* set detail panel */
                                if (layer_item.layer_detail) {
                                    let newClickableLayer = layer_item.layer_detail;
                                    // newClickableLayer.name = 'geojson:' + layer_item.layer_url;
                                    newClickableLayer.name = layer_item.id
                                    newClickableLayer.mode = newClickableLayer.type;
                                    newClickableLayer.type = 'modular';
                                    newClickableLayer.layerSource = layer_item.layer_type;
                                    clickableLayers.push(newClickableLayer);
                                }
                            }
                            /*process ArcgisREST layer*/
                            else if (layer_item.layer_type === 'arcgisrest' && layer_item.layer_url != null) {
                                layers[layer_item.id] = new Tile({
                                    visible: false,
                                    source : new TileArcGISRest({
                                        url        : layer_item.layer_url,
                                        crossOrigin: 'anonymous'
                                    })
                                });

                                layers[layer_item.id].set('name', layer_item.label);
                                layers[layer_item.id].set('clickable_name', 'geojson:' + layer_item.layer_url);

                                layers[layer_item.id].set('layerId', layer_item.id);
                                layers[layer_item.id].set('parentId', layer.id);
                                layers[layer_item.id].set('parentName', layer.title);

                                map.addLayer(layers[layer_item.id]);

                                /* set layer error handler */
                                const source = layers[layer_item.id].getSource();

                                source.on('tileloaderror', (evt) => {
                                    if (source === evt.target) {
                                        if (this.props.geoserverAlertPopupData.status === false && this.props.geoserverAlertPopupData.layerName != layers[layer_item.id].get('name')) {
                                            console.log(`tileloaderror: ${layer_item.layer_workspace}:${layer_item.layer_name}`);
                                            /* check if layer active */
                                            const isActiveLayer = this.props.activeLayers.find(obj => {
                                                return obj.id === layer.id;
                                            });
                                            if (isActiveLayer) {
                                                if(isActiveLayer.layer_active.mode === 'radio' || isActiveLayer.layer_active.mode === 'checkbox'){
                                                    isActiveLayer.layer_active.layer_lists.forEach(function(subLayer, index){
                                                        if (subLayer.id === layer_item.id){
                                                            subLayer.is_active = false;
                                                        }
                                                    });
                                                    this.props.activateSubLayer(isActiveLayer);
                                                    /* display error popup */
                                                    this.props.displayGeoserverAlertPopup({
                                                        status   : true,
                                                        layerName: layers[layer_item.id].get('name'),
                                                    });
                                                }
                                                else {
                                                    this.props.activateLayer(layer);
                                                    /* display error popup */
                                                    this.props.displayGeoserverAlertPopup({
                                                        status   : true,
                                                        layerName: layer.title,
                                                    });
                                                }
                                            }
                                        }
                                    }
                                });

                                /* set detail panel */
                                // if (layer_item.layer_detail) {
                                //     let newClickableLayer = layer_item.layer_detail;
                                //     // newClickableLayer.name = 'geojson:' + layer_item.layer_url;
                                //     newClickableLayer.name = layer_item.id
                                //     newClickableLayer.mode = newClickableLayer.type;
                                //     newClickableLayer.type = 'modular';
                                //     newClickableLayer.layerSource = layer_item.layer_type;
                                //     clickableLayers.push(newClickableLayer);
                                // }
                            }
                        });
                    }
                });
            });
        }
        /* set layers visible false */
        else {
            Object.keys(layers).forEach(layerName => {
                layers[layerName].setVisible(false);
            });

        }

        /* set layers visible, zindex and visibility*/
        const totalActiveLayers = this.props.activeLayers.length
        this.props.activeLayers.map((layer, index) => {
            if (layer.layer_active && layer.layer_active.layer_lists) {
                if (layer.layer_active.mode === 'checkbox' || layer.layer_active.mode === 'radio' || layer.layer_active.type === 'dropdown') {
                    layer.layer_active.layer_lists.map((layer_item, index_list) => {
                        if (layer_item.is_active) {
                            if (layers[layer_item.id]) {
                                layers[layer_item.id].setVisible(layer.hide !== true);
                                layers[layer_item.id].setZIndex((totalActiveLayers * 1000) - (index * 100) - index_list);
                                layers[layer_item.id].setOpacity(layer.opacity / 100);
                                if (layer_item.layer_type === 'tilewms' || layer_item.layer_type === 'imagewms') {
                                    layers[layer_item.id].getSource().updateParams({
                                        'CQL_FILTER': layer_item.layer_filter
                                    });

                                    /* hotspot extra CQL filter */
                                    if(layer.id === parseInt(process.env.MIX_MAP_HOTSPOT_ID)){
                                        let hotspotCqlFilter = '';
                                        if(this.props.hotspotFilterData.source.value === 'MODIS'){
                                            hotspotCqlFilter += " and (satelit = 'terra' or satelit = 'aqua')";
                                            if(this.props.hotspotFilterData.confidenceLevel.value === 30){
                                                hotspotCqlFilter += " and tingkat_kepercayaan >= '30'";
                                            } else if(this.props.hotspotFilterData.confidenceLevel.value === 80){
                                                hotspotCqlFilter += " and tingkat_kepercayaan >= '80'";
                                            }
                                        }
                                        if(this.props.hotspotFilterData.source.value === 'VIIRS'){
                                            hotspotCqlFilter += " and (satelit = 'snpp' or satelit = 'noaa20')";
                                            if(this.props.hotspotFilterData.confidenceLevel.value === 30){
                                                hotspotCqlFilter += " and tingkat_kepercayaan >= '8'";
                                            } else if(this.props.hotspotFilterData.confidenceLevel.value === 80){
                                                hotspotCqlFilter += " and tingkat_kepercayaan >= '9'";
                                            }
                                        }
                                        if(this.props.hotspotFilterData.source.value === 'LANDSAT'){
                                            hotspotCqlFilter += " and (satelit = 'landsat8')";
                                            if(this.props.hotspotFilterData.confidenceLevel.value === 30){
                                                hotspotCqlFilter += " and tingkat_kepercayaan >= '8'";
                                            } else if(this.props.hotspotFilterData.confidenceLevel.value === 80){
                                                hotspotCqlFilter += " and tingkat_kepercayaan >= '9'";
                                            }
                                        }
                                        layers[layer_item.id].getSource().updateParams({
                                            'CQL_FILTER': layer_item.layer_filter + hotspotCqlFilter
                                        });
                                    }
                                }
                            }
                        }
                    });
                }
                else {
                    layer.layer_active.layer_lists.map((layer_item, index_list) => {
                        if (layers[layer_item.id]) {
                            layers[layer_item.id].setVisible(layer.hide !== true);
                            layers[layer_item.id].setZIndex((totalActiveLayers * 1000) - (index * 100) - index_list);
                            layers[layer_item.id].setOpacity(layer.opacity / 100);
                            if (layer_item.layer_type === 'tilewms' || layer_item.layer_type === 'imagewms') {
                                layers[layer_item.id].getSource().updateParams({
                                    'CQL_FILTER': layer_item.layer_filter
                                });

                                /* hotspot extra CQL filter*/
                                if(layer.id === parseInt(process.env.MIX_MAP_HOTSPOT_ID)){
                                    let hotspotCqlFilter = '';
                                    if(this.props.hotspotFilterData.source.value === 'MODIS'){
                                        hotspotCqlFilter += " and (satelit = 'terra' or satelit = 'aqua')";
                                        if(this.props.hotspotFilterData.confidenceLevel.value === 30){
                                            hotspotCqlFilter += " and tingkat_kepercayaan >= '30'";
                                        } else if(this.props.hotspotFilterData.confidenceLevel.value === 80){
                                            hotspotCqlFilter += " and tingkat_kepercayaan >= '80'";
                                        }
                                    }
                                    if(this.props.hotspotFilterData.source.value === 'VIIRS'){
                                        hotspotCqlFilter += " and (satelit = 'snpp' or satelit = 'noaa20')";
                                        if(this.props.hotspotFilterData.confidenceLevel.value === 30){
                                            hotspotCqlFilter += " and tingkat_kepercayaan >= '8'";
                                        } else if(this.props.hotspotFilterData.confidenceLevel.value === 80){
                                            hotspotCqlFilter += " and tingkat_kepercayaan >= '9'";
                                        }
                                    }
                                    if(this.props.hotspotFilterData.source.value === 'LANDSAT'){
                                        hotspotCqlFilter += " and (satelit = 'landsat8')";
                                        if(this.props.hotspotFilterData.confidenceLevel.value === 30){
                                            hotspotCqlFilter += " and tingkat_kepercayaan >= '8'";
                                        } else if(this.props.hotspotFilterData.confidenceLevel.value === 80){
                                            hotspotCqlFilter += " and tingkat_kepercayaan >= '9'";
                                        }
                                    }
                                    layers[layer_item.id].getSource().updateParams({
                                        'CQL_FILTER': layer_item.layer_filter + hotspotCqlFilter
                                    });
                                }
                            }
                        }
                    });
                }
            }
        });

        this.processAdhocLayer();
        this.processCoordinateSearchLayer();

        /* process zoom to extent */
        if (this.props.mapExtent.length) {
            // const extent = Projection.transformExtent(this.props.mapExtent, 'EPSG:4326', 'EPSG:4326');
            const extent = transformExtent(this.props.mapExtent, 'EPSG:4326', 'EPSG:4326');
            map.getView().fit(extent, {duration: 300});
        }

        /* process zoom and change center*/
        if (snapshot.updateMapProperties) {
            map.getView().animate({
                center  : this.props.mapProperties.center,
                zoom    : this.props.mapProperties.zoom,
                duration: 300
            });
        }
        map.updateSize();

        /* remove clicked layer */
        if (!this.props.detailPanelData.status && !this.props.mapTooltipData.status) {
            map.removeLayer(clickedLayer);
            map.removeLayer(clickedLayerInner);
            map.removeLayer(radiusLayer);
        } else {
            if(this.props.detailPanelData.isSearch !== true) {
                if (this.props.detailPanelData.layerId) {
                    this.drawClickedLayer(this.props.detailPanelData.feature, layers[this.props.detailPanelData.layerId]);
                } else if (this.props.mapTooltipData.layerId) {
                    this.drawClickedLayer(this.props.mapTooltipData.feature, layers[this.props.mapTooltipData.layerId]);
                }
            }
        }

        this.drawModeHandler();
    };

    /**
     * Coordinate search processing
     */
    processCoordinateSearchLayer() {
        if (this.props.coordinateSearchLayer.status) {
            const marker = new Feature(new Point(this.props.coordinateSearchLayer.coordinate));
            marker.setStyle(new Style({
                image: new Icon(({
                    anchor: [0.5, 1],
                    src   : '/img/maps/icon/point-marker.svg',
                })),
            }));
            coordinateSearchLayerSource.addFeature(marker);
        } else {
            coordinateSearchLayer.getSource().clear();
        }
    }

    /**
     * adhoc layer processing
     */
    processAdhocLayer() {
        adhocLayersIndex = [];
        this.props.activeLayers.map((layer, index) => {
            if (layer.is_adhoc) {
                /* check if layer exist in current object*/
                if (typeof adhocLayers[layer.id] === 'undefined') {
                    // does not exist
                    /* layer hasnt been created before then we should create one */
                    let layer_item = layer.layer_active.layer_lists[0];
                    if (layer_item.layer_type === 'arcgisrest') {
                        adhocLayers[layer.id] = new Tile({
                            visible: false,
                            source: new TileArcGISRest({
                                url        : layer_item.layer_url,
                                crossOrigin: 'anonymous'
                            })
                        });

                        map.addLayer(adhocLayers[layer.id]);

                    } else if (layer_item.layer_type === 'json') {
                        adhocLayers[layer.id] = new Vector({
                            visible: false,
                            source: new VectorSource({
                                url        : layer_item.layer_file,
                                format     : new GeoJSON(),
                                crossOrigin: 'anonymous',
                            }),
                            style : new Style({
                                image: new CircleStyle({
                                    radius: 5,
                                    fill  : new Fill({
                                        color: '#303030'
                                    }),
                                    stroke: new Stroke({
                                        color: '#ffffff',
                                        width: 1
                                    })
                                })
                            })
                        });

                        map.addLayer(adhocLayers[layer.id]);
                    } else if (layer_item.layer_type === 'wms') {
                        adhocLayers[layer.id] = new Tile({
                            visible: false,
                            source : new TileWMS({
                                url        : layer_item.layer_url,
                                params     : {
                                    'LAYERS' : layer_item.layer_name,
                                    'TILED'  : true,
                                    'FORMAT' : 'image/png',
                                    'VERSION': '1.1.0',
                                },
                                serverType : 'geoserver',
                                crossOrigin: 'anonymous',
                            })
                        });
                        map.addLayer(adhocLayers[layer.id]);
                    }

                    adhocLayers[layer.id].set('name', layer.title);
                    /* error handling */
                    const source = adhocLayers[layer.id].getSource();
                    source.on('tileloaderror', (evt) => {
                        if (source === evt.target) {
                            if (this.props.geoserverAlertPopupData.status === false && this.props.geoserverAlertPopupData.layerName !== adhocLayers[layer.id].get('name')) {
                                console.log(`tileloaderror: adhoc layer ${layer.title}`);
                                this.props.activateLayer(layer);
                                /* display error popup */
                                this.props.displayGeoserverAlertPopup({
                                    status   : true,
                                    layerName: layer.title,
                                    isAdhoc : true,
                                });
                            }
                        }
                    });
                }

                adhocLayersIndex[layer.id] = index;
                adhocLayersObject[layer.id] = Object.assign({}, layer);
            }
        });

        for(let index in adhocLayersObject) {
            if (typeof adhocLayersIndex[index] === 'undefined') {
                map.removeLayer(adhocLayers[index]);
                delete adhocLayersObject[index];
                delete adhocLayers[index];
            } else {
                adhocLayers[index].setVisible(adhocLayersObject[index].hide !== true);
                adhocLayers[index].setZIndex((this.props.activeLayers.length * 1000) - (adhocLayersIndex[index] * 100));
                adhocLayers[index].setOpacity(adhocLayersObject[index].opacity / 100);
            }
        }
    }

    /**
     * draw mode handler
     */
    drawModeHandler() {
        map.removeInteraction(draw);
        if (this.props.drawMode.status !== false && this.props.drawMode.type !== false) {
            if (prevDrawType != this.props.drawMode.type) {
                drawSource.clear();
            }
            prevDrawType = this.props.drawMode.type;
            /* set draw initial style*/
            draw = new Draw({
                source: drawSource,
                type: this.props.drawMode.type,
                style: new Style({
                    image: new CircleStyle({
                        radius: 7,
                        fill  : new Fill({
                            // color: 'rgba(94, 147, 57, 1)',
                            color: '#303030',
                        }),
                    }),
                    stroke: new Stroke({
                        color: 'rgba(94, 147, 57, 1)',
                        width: 2,
                        lineDash: [5]
                    }),
                    fill: new Fill({
                        color: 'rgba(94, 147, 57, 0.3)',
                    }),
                    // LineString: new Stroke({
                    //     color: '#303030',
                    //     width: 2,
                    //     lineDash: [5]
                    // }),
                })
            });
            /* set draw layer style */
            let featureStyle = new Style({
                image: new CircleStyle({
                    radius: 7,
                    fill  : new Fill({
                        color: 'rgba(94, 147, 57, 1)',
                    }),
                }),
            });
            if(this.props.drawMode.type === 'Point'){
                featureStyle = new Style({
                    image: new Icon(({
                        anchor: [0.5, 1],
                        src: '/img/maps/icon/point-marker.svg',
                    })),
                });
                /* on drawing style */
                draw = new Draw({
                    source: drawSource,
                    type: this.props.drawMode.type,
                    style: new Style({
                        image: new CircleStyle({
                            radius: 7,
                            fill  : new Fill({
                                color: '#303030',
                            }),
                        }),
                        stroke: new Stroke({
                            color: 'rgba(94, 147, 57, 1)',
                            width: 2,
                            lineDash: [5]
                        }),
                        fill: new Fill({
                            color: 'rgba(94, 147, 57, 0.3)',
                        }),
                    }),
                });
                if(this.props.drawMode.data.coordinate && this.props.drawMode.isUpdate) {
                    const prevFeature = drawSource.getFeatures()[0];
                    if(prevFeature) {
                        prevFeature.getGeometry().setCoordinates(this.props.drawMode.data.coordinate);
                    }
                }
            } else if(this.props.drawMode.type === 'LineString') {
                featureStyle = function (feature) {
                    const geometry = feature.getGeometry();
                    const styles = [
                        new Style({
                            stroke: new Stroke({
                                color: '#303030',
                                width: 2,
                            })
                        })
                    ];
                    /* start and end point style */
                    geometry.forEachSegment(function (start, end) {
                        styles.push(
                            new Style({
                                geometry: new Point(start),
                                image: new CircleStyle({
                                    radius: 7,
                                    fill  : new Fill({
                                        color: '#303030',
                                    }),
                                    stroke: new Stroke({
                                        color: '#FFFFFF',
                                        width: 2
                                    })
                                }),
                            })
                        );
                        styles.push(
                            new Style({
                                geometry: new Point(end),
                                image: new CircleStyle({
                                    radius: 7,
                                    fill  : new Fill({
                                        color: '#ffc94d',
                                    }),
                                    stroke: new Stroke({
                                        color: '#303030',
                                        width: 2
                                    })
                                }),
                            })
                        );
                    });
                    return styles;
                }
                draw = new Draw({
                    source: drawSource,
                    type: this.props.drawMode.type,
                    maxPoints: 2,
                    style: new Style({
                        image: new CircleStyle({
                            radius: 7,
                            fill  : new Fill({
                                color: '#303030',
                            }),
                        }),
                        stroke: new Stroke({
                            color: '#303030',
                            width: 2,
                            lineDash: [5]
                        }),
                    }),
                });
                if(this.props.drawMode.data.coordinate && this.props.drawMode.isUpdate) {
                    const prevFeature = drawSource.getFeatures()[0];
                    if(prevFeature){
                        prevFeature.getGeometry().setCoordinates(this.props.drawMode.data.coordinate);
                        const length = getLength(prevFeature.getGeometry(), {
                            projection: 'EPSG:4326'
                        });
                        this.props.drawModeAnalyze({
                            coordinate: prevFeature.getGeometry().getCoordinates(),
                            length    : length,
                            area      : 0
                        });
                    }
                }
            } else if(this.props.drawMode.type === 'Polygon'){
                featureStyle = [
                    new Style({
                        fill: new Fill({
                            color: 'rgba(255, 201, 77, 0.3)',
                        }),
                        stroke: new Stroke({
                            color: '#303030',
                            width: 2,
                        }),
                    }),
                    /* point edges style */
                    new Style({
                        image: new CircleStyle({
                            radius: 7,
                            fill  : new Fill({
                                color: '#ffffff',
                            }),
                            stroke: new Stroke({
                                color: '#303030',
                                width: 2
                            })
                        }),
                        geometry: function (feature) {
                            // return the coordinates of the first ring of the polygon
                            const coordinates = feature.getGeometry().getCoordinates()[0];
                            return new MultiPoint(coordinates);
                        },
                    })
                ];

                /* on drawing style*/
                draw = new Draw({
                    source: drawSource,
                    type: this.props.drawMode.type,
                    style:
                        new Style({
                            image: new CircleStyle({
                                radius: 7,
                                fill: new Fill({
                                    color: '#303030',
                                }),
                            }),
                            stroke: new Stroke({
                                // color: 'rgba(94, 147, 57, 1)',
                                color: '#303030',
                                width: 2,
                                lineDash: [5]
                            })
                        })
                });
            }

            drawVector.setStyle(featureStyle);
            map.addInteraction(draw);

            /* clear all previous drawed feature to ensure only one feature drawed*/
            draw.on('drawstart', (evt) => {
                drawSource.clear();
            });

            draw.on('drawend', (evt) => {
                const feature = evt.feature;
                const geom = feature.getGeometry();
                const coordinate = feature.getGeometry().getCoordinates();
                let length = 0;
                let area = 0;
                if (geom instanceof Polygon) {
                    area = getArea(geom, {
                        projection: 'EPSG:4326'
                    });
                    length = getLength(geom, {
                        projection: 'EPSG:4326'
                    });

                    /* regiter polygon to geoserver*/
                    self.post('/draw/polygon/register', {
                        coordinates: coordinate[0]
                    }).then((response) => {
                        this.props.drawModePolygonRegister(response.data);
                    }).catch((error) => {
                        console.log(error);
                    });

                } else if (geom instanceof LineString) {
                    length = getLength(geom, {
                        projection: 'EPSG:4326'
                    });
                }

                this.props.drawModeAnalyze({
                    coordinate: coordinate,
                    length    : length,
                    area      : area,
                    filter    : {
                        startDate      : moment().add(-1, 'month').format('YYYY-MM-DD'),
                        endDate        : moment().format('YYYY-MM-DD'),
                        confidenceLevel: 30,
                        source         : 'ALL',
                    }
                });
            });
        } else {
            /* remove all features */
            drawSource.clear();
        }
    }

    /**
     * Format length output.
     * @param {LineString} line The line.
     * @return {string} The formatted length.
     */
    formatLength = function (line) {
        var length = getLength(line, {
            projection: 'EPSG:4326'
        });
        var output;
        if (length > 100) {
            output = Math.round((length / 1000) * 100) / 100 + ' ' + 'km';
        } else {
            output = Math.round(length * 100) / 100 + ' ' + 'm';
        }
        return output;
    };

    /**
     * Format area output.
     * @param {Polygon} polygon The polygon.
     * @return {string} Formatted area.
     */
    formatArea = function (polygon) {
        var area = getArea(polygon);
        var output;
        if (area > 10000) {
            output = Math.round((area / 1000000) * 100) / 100 + ' ' + 'km<sup>2</sup>';
        } else {
            output = Math.round(area * 100) / 100 + ' ' + 'm<sup>2</sup>';
        }
        return output;
    };

    /**
     * pointer move event handler, feature detect and change pointer tu cursor
     */
    mapHoverEventHandler() {
        map.on('pointermove', (evt) => {
            if (evt.dragging) {
                return;
            }
            const pixel = map.getEventPixel(evt.originalEvent);
            const hit = map.forEachLayerAtPixel(pixel, (layer) => {
                let hitClickableLayer = false;
                clickableLayers.forEach((clickableLayer) => {
                    // if (layer.get('clickable_name') === clickableLayer.name) {
                    if (layer.get('layerId') === clickableLayer.name) {
                        hitClickableLayer = true;
                    }
                });
                if (hitClickableLayer) {
                    return true;
                }
            });
            map.getTargetElement().style.cursor = hit ? 'pointer' : 'default';
        });
    }

    /**
     * map single click event handler
     */
    mapClickEventHandler() {
        map.on('singleclick', (evt) => {
            if(this.props.drawMode.status !== false) {
                return false;
            }
            if(this.props.opacitySliderData.status === true) {
                this.props.displayOpacitySlider({status: false});
            }
            if (evt.dragging) {
                return;
            }
            let clickedLayers = [];

            /* raster layer click handling */
            map.forEachLayerAtPixel(evt.pixel, (layer) => {
                const layerName = layer.get('name');
                const layerSource = layer.getSource();
                let hit = false;
                if (layerName && !layerName.endsWith('basemap')) {
                    /* if wms */
                    if (typeof layerSource.getGetFeatureInfoUrl === 'function') {
                        clickableLayers.forEach((clickableLayer) => {
                            if (hit === true) {
                                return;
                            }
                            if (layer.get('layerId') === clickableLayer.name) {
                                /* get feature url */
                                const geoserverUrl = layer.getSource().getGetFeatureInfoUrl(evt.coordinate, map.getView().getResolution(), 'EPSG:4326', {
                                    INFO_FORMAT: 'application/json'
                                });

                                clickedLayers.push({
                                    name          : layerName,
                                    geoserverUrl  : geoserverUrl,
                                    layerId       : layer.get('layerId'),
                                    position      : evt.pixel,
                                    clickableLayer: clickableLayer,
                                    'parentId'      : layer.get('parentId'),
                                    'parentName'    : layer.get('parentName')
                                });
                            }
                        });
                        if (hit) {
                            return true;
                        }
                    }
                }
            });

            /* json layer handling */
            clickableLayers.forEach((clickableLayer) => {
                if(clickableLayer.layerSource === 'json') {
                    const feature = map.forEachFeatureAtPixel(evt.pixel, (feature, layer) => {
                        if (layer.get('layerId') === clickableLayer.name) {
                            clickedLayers.push({
                                'name'          : layer.get('name'),
                                'feature'       : JSON.parse(new GeoJSON().writeFeature(feature)),
                                'layerId'       : layer.get('layerId'),
                                'clickableLayer': clickableLayer,
                                'parentId'      : layer.get('parentId'),
                                'parentName'    : layer.get('parentName')
                            });
                            return true;
                        }
                        return true;
                    },{
                        layerFilter: function (layer) {
                            return layer.get('layerId') === clickableLayer.name;
                        }
                    });
                }
            });

            if (clickedLayers.length > 0) {
                this.props.displayMultistack({
                    status  : true,
                    data    : clickedLayers,
                    position: evt.pixel,
                });
            }
        });
    }

    /**
     * draw vector layer of clicked feature
     *
     * @param data
     * @param layer
     * @param color
     */
    drawClickedLayer(data, layer, color = null) {
        /* get layer color */
        const layerParentObj = this.props.activeLayers.find(obj => {
            return obj.id === layer.get('parentId');
        });
        if(!layerParentObj){
            this.props.displayDetailPanel({status: false});
            this.props.displayMapTooltip({status: false});
            return false;
        }

        const layerObj = layerParentObj.layer_active.layer_lists.find(obj => {
            return obj.id === layer.get('layerId');
        });

        /* define layer style */
        const myStyle = new Style({
            fill  : new Fill({
                color: 'rgba(0,0,0,0.2)'
            }),
            stroke: new Stroke({
                color: '#FFFFFF',
                width: 2
            }),
            image: new CircleStyle({
                radius: 16,
                fill  : new Fill({
                    color: hexToRgba('#FFFFFF', 0.5)
                }),
                stroke: new Stroke({
                    color: layerObj.hex,
                    width: 2
                })
            })
        });

        const innerStyle = new Style({
            image: new CircleStyle({
                radius: 9,
                fill  : new Fill({
                    color: layerObj.hex,
                }),
                stroke: new Stroke({
                    color: layerObj.hex,
                    width: 0
                })
            })
        });

        /* clean up clicked layer */
        map.removeLayer(clickedLayer);
        map.removeLayer(clickedLayerInner);
        map.removeLayer(radiusLayer);

        const vectorSource = new VectorSource({
            projection: map.getView().getProjection(),
            features  : new GeoJSON().readFeatures(data)
        });

        /* default clicked layer variable */
        clickedLayer = new Vector({
            source: vectorSource,
            style : myStyle
        });

        if (data.type === 'FeatureCollection') {
            /* if feature type layer is point draw extra circle */
            if(data.features[0].geometry) {
                if (data.features[0].geometry.type === 'Point') {
                    clickedLayerInner = new Vector({
                        source: vectorSource,
                        style : innerStyle
                    });
                    map.addLayer(clickedLayerInner);
                    clickedLayerInner.setZIndex(layer.getZIndex() + 2);
                }
            }
        } else if (data.type === 'Feature') {
            clickedLayerInner = new Vector({
                source: vectorSource,
                style : innerStyle
            });
            map.addLayer(clickedLayerInner);
            clickedLayerInner.setZIndex(layer.getZIndex() + 2);
        }

        /* hostpot radius drawing handler */
        if (parseInt(process.env.MIX_MAP_HOTSPOT_LAYERITEM_ID) === layer.get('layerId') && this.props.hotspotMode === 'deepwell-analysis') {
            /* set radius */
            const radius = 100;

            /* create feature with circularPolyggon (not geom.circle) */
            const vectorSource = new VectorSource({
                projection: map.getView().getProjection(),
                features  : [
                    new Feature(circularPolygon(data.features[0].geometry.coordinates, radius, 64)),
                ],
            });

            /* create the vector layer and style */
            radiusLayer = new Vector({
                source: vectorSource,
                style : new Style({
                    fill: new Fill({
                        color: hexToRgba(layerObj.hex, 0.2)
                    }),
                })
            });

            map.addLayer(radiusLayer);
            radiusLayer.setZIndex(layer.getZIndex() - 1);
        }

        /* add layer to map and set z index */
        map.addLayer(clickedLayer);
        clickedLayer.setZIndex(layer.getZIndex() + 1);
    }

    render() {
        return (
            <div id="map"/>
        );
    }
}

const mapActionToProps = {
    updateMapProperties,
    zoomMapToExtent,
    updateBaseLayer,
    displayDetailPanel,
    displayGeoserverAlertPopup,
    activateLayer,
    displayOpacitySlider,
    displayMapTooltip,
    activateSubLayer,
    displayMultistack,
    drawModeAnalyze,
    drawModePolygonRegister,
};

const MapStateToProps = (state) => {
    return {
        activeLayers           : state.activeLayers,
        layers                 : state.layers,
        mapProperties          : state.mapProperties,
        baseLayer              : state.baseLayer,
        mapExtent              : state.mapExtent,
        detailPanelData        : state.detailPanelData,
        mapTooltipData         : state.mapTooltipData,
        opacitySliderData      : state.opacitySliderData,
        geoserverAlertPopupData: state.geoserverAlertPopupData,
        hotspotFilterData      : state.hotspotFilterData,
        drawMode               : state.drawMode,
        hotspotMode            : state.hotspotMode,
        coordinateSearchLayer  : state.coordinateSearchLayer,
        // clickedLayerData       : state.clickedLayerData,
    };
};

export default connect(MapStateToProps, mapActionToProps)(MapComponent);
